import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SellerGst = createAsyncThunk(
  "sellerGst/SellerGst",
  async (data, thunkAPI) => {
    try {
      const SellerId = localStorage.getItem("SellerloginData");
      const response = await axios.post(
        `${endPoint.SellerGstApi}/${SellerId}`,
        {
          gstNumber: data?.gstNumber,
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SellerGstSlice = createSlice({
  name: "SellerGstData",
  initialState: {
    SellerGstData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SellerGst.fulfilled, (state, action) => {
        state.SellerGstData = action.payload;
      })
      .addCase(SellerGst.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SellerGstSlice.reducer;
